import { useState } from 'react';
import { useCurrentUser } from '@/auth/AuthContext';
import { ListaLinks } from '@/components/ListaLinks';
import { PagamentosExternos } from '@/components/PagamentosExternos';
import { Alert } from '@/components/ui';
import { formatBRL } from '@/lib/format';
import type { LinkPagamentoItem } from '@/lib/pagamentos';
import { useApi } from '@/lib/useApi';

type Filtro = '' | 'AGUARDANDO' | 'PAGO';

/** Links de pagamento gerados no sistema e se o cliente já pagou. */
export function PagamentosPage() {
  const me = useCurrentUser();
  const gestao = me.role === 'ADMIN' || me.role === 'GESTOR';
  const [filtro, setFiltro] = useState<Filtro>('');
  const { data, error, reload } = useApi<LinkPagamentoItem[]>(`/crm/payment-links${filtro ? `?status=${filtro}` : ''}`, 60_000);
  const pagos = data?.filter((l) => l.status === 'PAGO') ?? [];
  const totalPago = pagos.reduce((a, l) => a + Number(l.valorPago ?? l.valorCartao), 0);

  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Links de pagamento</h1>
          <p className="muted">
            O Mercado Pago avisa o sistema quando o cliente paga. {gestao ? 'Links de toda a equipe.' : 'Seus links.'}
          </p>
        </div>
        <div className="row tight" role="tablist">
          {(['', 'AGUARDANDO', 'PAGO'] as Filtro[]).map((f) => (
            <button key={f || 'todos'} type="button" role="tab" aria-selected={filtro === f} className={`chip ${filtro === f ? 'chip--orange' : 'chip--gray'}`} onClick={() => setFiltro(f)}>
              {f === '' ? 'Todos' : f === 'PAGO' ? 'Pagos' : 'Aguardando'}
            </button>
          ))}
        </div>
      </header>
      {error && <Alert>{error}</Alert>}
      {data && pagos.length > 0 && (
        <p className="muted">
          {pagos.length} pago(s) · {formatBRL(totalPago.toFixed(2))}
        </p>
      )}
      <section className="card">{!data ? <p className="muted">Carregando…</p> : <ListaLinks links={data} onChanged={() => void reload()} mostrarConsultor={gestao} />}</section>
      {gestao && <PagamentosExternos />}
    </div>
  );
}
